import React, {useEffect, useState} from 'react';

const FullMailBasicInfo = (props) => {
    const [mailTemplate, setMailTemplate] = useState({name: "", note: ""});

    const {template, onChange} = props

    useEffect(() => {
        setMailTemplate({...template})
    }, [template])

    const onChangeInputItem = (values, field) => {
        mailTemplate[field] = values
        setMailTemplate({...mailTemplate})
        onChange(mailTemplate)
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title'><b>Basic info</b></h3>
                </div>
                <div className='card-body'>
                    <div className={"row"}>
                        <div className='col-sm-12'>
                            <div className="form-group">
                                <label>Tên template</label>
                                <input className="form-control" value={mailTemplate.name}
                                       name={"name"}
                                       onChange={(event) => onChangeInputItem(event.target.value, "name")}
                                       type={"text"}/>
                            </div>
                            <div className="form-group">
                                <label>Note</label>
                                <input className="form-control" value={mailTemplate.note}
                                       name={"note"}
                                       onChange={(event) => onChangeInputItem(event.target.value, "note")}
                                       type={"text"}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FullMailBasicInfo;
